import { RootState } from "store/types";

export const selectProjectsList = (state: RootState) => state.projects.projectsList;